var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('permission-container',{attrs:{"permissionId":_vm.permissionId}},[_c('span',{staticClass:"wrap-text"},[_vm._v(_vm._s(_vm.clientName||''))])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.clientCode||''))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11ad8120","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/erp/components/render/ClientInfoRender.vue
// module id = null
// module chunks = 